module.exports = __webpack_public_path__ + "static/media/no_vip_card.4981c841.png";